<template>
    <v-dialog v-model="open" scrollable>
        <v-card elevation="10" class="rounded-xl">
            <v-card-title class="headline font-weight-bold d-flex align-center" style="background: #f5f7fa">
                <v-btn color="primary" rounded @click="exportCSV">
                    <v-icon color="white" class="mr-1">mdi-table</v-icon>
                    Export Data
                </v-btn>

                <!-- {{ table && table.name ? table.name : "Tabelle" }} -->
                <v-spacer />
                <v-btn icon @click="close" color="grey darken-1">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-4">
                <!-- Chart anzeigen, falls vorhanden -->
                <v-card v-if="table && table.chart && table.chart.labels && table.chart.datasets && table.chart.datasets.length" class="mb-6 rounded-lg elevation-2">
                    <v-card-title class="subtitle-1 font-weight-medium pb-4 mb-2" style="background: #f5f7fa">
                        <v-icon left color="primary" class="mr-2">mdi-chart-line</v-icon>
                        Chart
                    </v-card-title>

                    <v-card-text>
                        <line-chart :dataChart="table.chart" :options="chartOptions" :countGraph2="renderChart" style="width: 100%" />
                    </v-card-text>
                </v-card>
                <v-data-table id="datatable_ai" v-if="table" :headers="tableHeaders" :items="table.items" class="elevation-1 rounded-lg" style="background: #fff">
                    <template v-slot:item="props">
                        <tr>
                            <td v-for="col in table.columns" :key="col.column" class="py-2 px-3">
                                <template v-if="getCellValue(props.item, col) && String(getCellValue(props.item, col)).length > 40">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="cell-ellipsis" v-bind="attrs" v-on="on">
                                                {{ truncate(getCellValue(props.item, col), 40) }}
                                            </span>
                                        </template>
                                        <span style="white-space: pre-line; max-width: 400px; display: block">
                                            {{ getCellValue(props.item, col) }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    <span class="cell-ellipsis">
                                        {{ getCellValue(props.item, col) }}
                                    </span>
                                </template>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:headerCell="{ header }">
                        <th class="text-left font-weight-bold" style="background: #f5f7fa">
                            {{ header.text }}
                        </th>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import LineChart from "./charts/LineChart.js"
    export default {
        name: "KITableDialog",
        components: { LineChart },
        props: {
            value: Boolean,
            table: Object
        },
        data() {
            return {
                renderChart: 0,
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            labels: {
                                fontSize: 14,
                                usePointStyle: true,
                                pointStyle: "rectRounded"
                            }
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                font: { size: 13 }
                            }
                        },
                        x: {
                            ticks: {
                                font: { size: 13 }
                            }
                        }
                    }
                }
            }
        },
        computed: {
            open: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit("input", val)
                }
            },
            tableHeaders() {
                if (!this.table || !this.table.columns) return []
                return this.table.columns.map((col) => ({
                    text: col.column_name,
                    value: col.column
                }))
            }
        },
        mounted() {
            this.renderChart++
        },
        methods: {
            close() {
                this.open = false
            },
            getCellValue(item, col) {
                // Verschachtelte Felder wie "price.displayed_price"
                if (col.column.includes(".")) {
                    return col.column.split(".").reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : "-"), item)
                }
                // monthly_searches['2024-07'] usw.
                const match = col.column.match(/^(\w+)\['(.+)'\]$/)
                if (match) {
                    const obj = item[match[1]]
                    return obj ? obj[match[2]] : "-"
                }
                // Für Objekte
                if (col.type === "object" && typeof item[col.column] === "object") {
                    const obj = item[col.column]
                    if (obj && Object.keys(obj).length) {
                        return Object.entries(obj)
                            .map(([k, v]) => `${k}: ${v}`)
                            .join(", ")
                    }
                    return "-"
                }
                // Standard
                return item[col.column] !== undefined ? item[col.column] : "-"
            },
            truncate(text, length) {
                if (!text && text !== 0) return ""
                text = String(text)
                return text.length > length ? text.slice(0, length) + "…" : text
            },
            exportCSV() {
                if (!this.table || !this.table.items || !this.table.columns) return
                const headers = this.table.columns.map((col) => `"${col.column_name}"`).join(",")
                const rows = this.table.items.map((item) =>
                    this.table.columns
                        .map((col) => {
                            let val = this.getCellValue(item, col)
                            if (typeof val === "string") val = val.replace(/"/g, '""')
                            return `"${val}"`
                        })
                        .join(",")
                )
                const csvContent = [headers, ...rows].join("\r\n")
                const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
                const link = document.createElement("a")
                link.href = URL.createObjectURL(blob)
                link.setAttribute("download", (this.table.name || "export") + ".csv")
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
        }
    }
</script>

<style>
    .chart-card {
        background: #f9fafb;
        max-width: 500px;
        margin: 0 auto 24px auto;
        padding: 0;
    }
    .chart-card-content {
        padding: 8px 16px 8px 16px !important;
    }
    .chart-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cell-ellipsis {
        display: inline-block;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        cursor: pointer;
    }

    #datatable_ai .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        color: rgba(0, 0, 0, 0.6);
    }
    #datatable_ai > div.v-data-table__wrapper > table > thead > tr {
        white-space: nowrap !important;
        text-transform: uppercase !important;
        background-color: #f9fafb;
    }
    #datatable_ai > div.v-data-table__wrapper > table > thead > tr > th > span {
        font-weight: 100 !important;
    }
</style>
